import { createI18n } from 'vue-i18n'
import { cs } from './locales/cs'
import { en } from './locales/en'

export type AppLocale = 'cs' | 'en'

function initialLocale(): AppLocale {
  const stored = localStorage.getItem('tramnerd:locale')
  if (stored === 'cs' || stored === 'en') return stored
  return navigator.language.toLowerCase().startsWith('cs') ? 'cs' : 'en'
}

export const i18n = createI18n({
  legacy: false,
  locale: initialLocale(),
  fallbackLocale: 'en',
  messages: { cs, en },
})
